import { FC, useRef } from 'react'
import { Form, useNavigate } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'

// COMPONENTS
import * as Icons from '@icons'
import Button from '@components/atoms/button'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { useEmailIdContext } from '..'


const Component: FC<{}> = () => {
    const { resource } = useEmailIdContext()
    const { isLoaded, isSignedIn, user } = useUser()
    const navigate = useNavigate()

    const isPrimary = user?.isPrimaryIdentification(resource) ?? false
    const isVerified = resource.verification.status === 'verified' // ToDo: Handle additional Verification statuses

    function handleSetPrimary() {
        if (!isSignedIn || !isLoaded) return
        user.update({ primaryEmailAddressId: resource.id })
        handleBack()
    }

    const ref = useRef<HTMLDialogElement>(null)
    function promptDelete() { if (ref.current) ref.current.showModal() }
    function closePrompt() { if (ref.current) ref.current.close() }

    // ToDo: Error Handling
    async function handleDelete() {
        const res = await resource.destroy()
        console.log(res)
        handleBack()
    }

    function handleBack() {
        navigate('/account/profile')
    }

    return (<>
        <div className="flex flex-row items-center" style={{ gap: 'inherit' }}>
            <Icons.Email />
            <h4>{resource.emailAddress}</h4>
        </div>
        {(!isVerified && !isPrimary) && <Button to="./verify">Verify E-mail</Button>}
        {(isVerified && !isPrimary) && <Button onClick={handleSetPrimary}>Set as Primary</Button>}
        <a onClick={promptDelete} style={{ alignSelf: 'center', color: 'var(--splitcard-red-500)' }}>Delete Email</a>
        <dialog ref={ref}>
            <div>
                <Form className="flex flex-col items-stretch" onSubmit={handleDelete} style={{ maxWidth: 'calc(var(--max-content-width, 610px) - 4rem)', textAlign: 'left', margin: '1rem', background: 'var(--splitcard-white)', gap: '1rem', padding: '1rem', borderRadius: 'var(--border-radius)', overflowY: 'auto' }}>
                    <h2 style={{ textAlign: 'center' }}>Wait!</h2>
                    <p style={{ textAlign: 'center' }}>Are you sure you want to remove this E-mail Address?</p>
                    <div className='flex flex-row gap-2.5'>
                        <Button theme="secondary" style={{ flex: 1 }} formMethod="dialog" onClick={closePrompt}>Cancel</Button>
                        <Button theme="primary" style={{ flex: 1 }} type="submit" onClick={closePrompt}>Remove E-mail</Button>
                    </div>
                </Form>
            </div>
        </dialog>
    </>)
}

const ViewEmailRoute: RouteObject = {
    index: true,
    Component,
}

export { ViewEmailRoute }